import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SvgComponent } from '@app/base-components';
import { ButtonQaId, HabaQaId } from '@app/helpers';
import { ActiveCartService, Cart, I18nModule, OrderEntry, UrlModule } from 'haba-core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CartItemListComponent } from '../../cart/cart-item-list/cart-item-list.component';

@Component({
  selector: 'app-checkout-products',
  templateUrl: './checkout-products.component.html',
  styleUrls: ['./checkout-products.component.scss'],
  imports: [
    NgIf,
    RouterLink,
    SvgComponent,
    CartItemListComponent,
    AsyncPipe,
    I18nModule,
    UrlModule,
  ],
})
export class CheckoutProductsComponent implements OnInit {
  cart$: Observable<Cart>;
  entries$: Observable<OrderEntry[]>;
  baseQaId: HabaQaId;
  cartButton: ButtonQaId;
  constructor(
    private activeCartService: ActiveCartService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.cart$ = this.activeCartService.getActive();
    this.entries$ = this.activeCartService.getEntries().pipe(tap(() => this.cdr.detectChanges()));
    this.initIds();
  }

  private initIds(): void {
    this.baseQaId = HabaQaId.forPage(HabaQaId.page.reviewOrder);
    this.cartButton = this.baseQaId.getButtonId(HabaQaId.elements.button.cart);
  }
}
